module.exports = __webpack_public_path__ + "static/KNS-ISO-22301-3f0081de6d8f3c393772b5576667317f.png";